import script from "./ToastAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastAlert.vue?vue&type=script&setup=true&lang=js"

import "./ToastAlert.vue?vue&type=style&index=0&id=db01259a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db01259a"]])

export default __exports__